module.exports = __webpack_public_path__ + "dc5212f90e37b47de3a0a1d11c179dcb.woff";